"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFormalAttributes = exports.FormalAttributesProvider = void 0;
var formal_attributes_provider_1 = require("./formal-attributes.provider");
Object.defineProperty(exports, "FormalAttributesProvider", { enumerable: true, get: function () { return formal_attributes_provider_1.FormalAttributesProvider; } });
Object.defineProperty(exports, "useFormalAttributes", { enumerable: true, get: function () { return formal_attributes_provider_1.useFormalAttributes; } });
